var map = {
	"./bank.png": "a520",
	"./game.png": "d217",
	"./girl.png": "67c4",
	"./home.png": "6162",
	"./kiosk.png": "b1a3",
	"./man.png": "f404",
	"./man_dog.png": "3681",
	"./mother.png": "f58a",
	"./shop.png": "dace",
	"./tur.png": "dd06"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d166";